import { Component, ChangeDetectionStrategy } from '@angular/core';
var BsDatePickerComponent = (function () {
    function BsDatePickerComponent() {
    }
    BsDatePickerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bs-datepicker',
                    exportAs: 'bs-datepicker',
                    template: "\n<div class=\"bs-datepicker-multiple\">\n  <div class=\"left\">\n    <bs-date-picker-view bsRole=\"left\"></bs-date-picker-view>\n    <!--<bs-date-picker-view bsRole=\"right\"></bs-date-picker-view>-->\n  </div>\n  <div class=\"right\">\n    <bs-custom-range-picker></bs-custom-range-picker>\n  </div>\n  <!--<div class=\"bs-datepicker-btns\">-->\n    <!--<button class=\"label-success colored\"><span>Apply</span></button>-->\n    <!--<button><span>Cancel</span></button>-->\n  <!--</div>-->\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                },] },
    ];
    /** @nocollapse */
    BsDatePickerComponent.ctorParameters = function () { return []; };
    return BsDatePickerComponent;
}());
export { BsDatePickerComponent };
//# sourceMappingURL=bs-date-picker.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker2/bs-date-picker.component.js
// module id = 468
// module chunks = 103